const AreaChartSVG = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24"><rect fill="none" height="24" width="24"/><path fill="#fff" d="M17,7l-5-4l-5,7L3,7v13h18V7H17z"/></svg>
};

export default AreaChartSVG;